<script>
import baseMixins from '@/plans/ZOOM_MEETING/config/base';
import { mapGetters } from 'vuex';
import {
  BILLING_CYCLE,
  planTypes,
  maxBizAndBizPlusLicenseCount,
  ZOOM_MEETING_PRO_MIN_LICENSE,
} from '@/common/constants';
import { get } from 'lodash';
import audioUsCaMixin from '@/common/mixin/audio-us-ca-mixin';

export default {
  name: "pro2biz",
  mixins: [baseMixins, audioUsCaMixin],
  data() {
    return {
      showCategoryDesc: true,
    };
  },
  computed: {
    ...mapGetters(['boughtPlans', 'basicConfig', 'disableMonthly2AnnualTip']),
    boughtZonePlan() {
      return this.boughtPlans.find((p) => p.type === planTypes.ZOOM_MEETING);
    },
    supportMSQ() { return false; },
    maxHost() {
      const defaultMaxHosts = this.formPlan ? this.formPlan.max : maxBizAndBizPlusLicenseCount;
      const boughtZonePlanQuantity = get(this.boughtZonePlan, 'cartInfo.selected_number', defaultMaxHosts);
      return Math.max(boughtZonePlanQuantity, defaultMaxHosts);
    },
    isNormalCase() {
      const boughtZonePlanQuantity = get(this.boughtZonePlan, 'cartInfo.selected_number', 0);
      const defaultMaxHosts = this.formPlan ? this.formPlan.max : maxBizAndBizPlusLicenseCount;
      if (boughtZonePlanQuantity > ZOOM_MEETING_PRO_MIN_LICENSE) return false;
      return boughtZonePlanQuantity <= defaultMaxHosts;
    },
  },
  methods: {
    billingCycleDisabled({ billing_cycle }) {
      if (this.disableMonthly2AnnualTip && billing_cycle === BILLING_CYCLE.ANNUAL) {
        return this.disableMonthly2AnnualTip;
      }

      return this.getBillingCycleDisabledDesc(billing_cycle);
    },
  },
};
</script>
